import { Component, HostBinding, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { ToolsService } from '../../../../../../core/services/tools.service';
import {
  CmsBannerComponent,
  CmsBannerComponentMedia,
  CmsResponsiveBannerComponentMedia,
  OccConfig,
} from '@spartacus/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'custom-simple-responsive-banner',
  templateUrl: './simple-responsive-banner.component.html',
  styleUrl: './simple-responsive-banner.component.scss',
  standalone: false,
})
export class SimpleResponsiveBannerComponent implements OnInit, OnDestroy {
  @HostBinding('class.custom-simple-responsive-banner') isActive = true;
  component$ = this.componentData.data$;
  currentMedia$ = new BehaviorSubject<CmsBannerComponentMedia | undefined>(undefined);
  banner: CmsBannerComponent | undefined;

  subscriptions = new Subscription();
  resizeTimeout: any;

  constructor(
    private componentData: CmsComponentData<any>,
    private toolsService: ToolsService,
    protected sanitizer: DomSanitizer,
    protected config: OccConfig,
  ) {}

  ngOnInit(): void {
    this.getContent();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getContent() {
    this.subscriptions.add(
      this.component$.subscribe(banner => {
        this.banner = banner;
        this.updateMedia();
      }),
    );
  }

  updateMedia() {
    const currentMedias = this.toolsService.getCurrentMediaFormat(
      this.banner?.media as CmsResponsiveBannerComponentMedia,
    );

    this.currentMedia$.next({
      ...currentMedias,
      ...{
        url: (this.config.backend?.occ?.baseUrl || '') + currentMedias.url,
      },
    });
  }

  @HostListener('window:resize') onResize() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }

    this.resizeTimeout = setTimeout(() => {
      this.updateMedia();
    }, 500);
  }
}
